import { render, staticRenderFns } from "./FooterSocial.vue?vue&type=template&id=d2580c64&scoped=true&"
import script from "./FooterSocial.vue?vue&type=script&lang=js&"
export * from "./FooterSocial.vue?vue&type=script&lang=js&"
import style0 from "./FooterSocial.vue?vue&type=style&index=0&id=d2580c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2580c64",
  null
  
)

export default component.exports